import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import styled from 'styled-components';
import AdminBoardService from '../../service/AdminBoardService';
import Button from '../atom/Button';
import SelectBox from '../atom/SelectBox';
import TitleHeader from '../modecules/TitleHeader';
import { getServiceLabel } from '../../util/Lookups';
import { getRawFilesFromItem, normalizeName } from '../../util/FileHelpers';

// import { myAssignPerson } from "../AssignPersonState";
// import { useRecoilValue } from "recoil";

const AdminVocDtailWrap = styled.div`
  margin-top: 50px;
  width: 60%;
  @media ${props => props.theme.device.laptop} {
    width: 80%;
  }
`;

const AdminVocDetailBoardView = styled.div``;

const AdminDetailNumber = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 50px;
  color: #388fc0;
  font-weight: 800;
`;

const AdminDetailBoardViewTop = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #388fc0;
  padding-bottom: 17px;
  @media ${props => props.theme.device.tablet} {
    flex-direction: column;
    justify-content: center;
  }
`;

const AdminVocDetailBoardViewTitle = styled.div`
  font-size: 22px;
  color: #666;
  font-weight: 600;
  min-width: 150px;
`;

const AdminVocDetailBoardViewCnt = styled.div`
  display: flex;
  align-items: center;
  @media ${props => props.theme.device.tablet} {
    flex-direction: column;
  }
`;

const CntUsername = styled.div`
  font-size: 17px;
  color: #888;
  margin-left: 17px;
  font-weight: 400;
  @media ${props => props.theme.device.mobile} {
    font-size: 12px;
  }
`;

const CntDate = styled.div`
  font-size: 17px;
  color: #888;
  margin-left: 17px;
  font-weight: 400;
  @media ${props => props.theme.device.mobile} {
    font-size: 12px;
  }
`;
const AdminVocDetailPhoneNumber = styled.div`
  font-size: 22px;
  font-weight: 500;
  margin-top: 10px;
  color: #666;
`;

const AdminVocDetailBoardViewContent = styled.div`
  width: 100%;
  font-size: 18px;
  font-weight: 500;
  color: #666;
  line-height: 1.4;
  min-height: 400px;
  margin-top: 20px;
  white-space: pre-wrap;
  padding-bottom: 30px;
  word-break: break-all;
`;

const AdminVocDetailBoardViewFile = styled.div`
  display: flex;
  align-items: center;
`;

const AdminVocDetailBoardViewFileLine = styled.div`
  border-bottom: 2px solid #dcdcdc;
  padding-bottom: 17px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  @media ${props => props.theme.device.tablet} {
    flex-direction: column;
  }
`;

const AdminDetailFileWrap = styled.div`
  display: flex;
  @media ${props => props.theme.device.tablet} {
    margin-bottom: 20px;
  }
`;
const AdminVocServiceWrap = styled.div`
  display: flex;
  align-items: center;
`;

const AdminVocDetailBoardViewFileTitle = styled.label`
  font-size: 20px;
  color: #666;
  font-weight: 600;
  margin-right: 12px;
`;

const AdminVocDetailBoardViewFilename = styled.label`
  font-size: 16px;
  color: #888;
  &:hover {
    font-size: 16px;
    color: #888;
    cursor: pointer;
    border-bottom: 1px solid black;
  }
`;

const AdminVocDetailBoardViewOrigin = styled.label`
  font-size: 20px;
  color: #666;
  font-weight: 600;
  margin-right: 12px;
`;

const AdminVocDetailBoardViewOriginCnt = styled.label`
  font-size: 16px;
  color: #888;
  width: 100px;
`;

const AdminVocDetailButton = styled.div`
  display: flex;
  justify-content: space-between;
  @media ${props => props.theme.device.tablet} {
    flex-direction: column;
  }
`;

const AdminVocWritePageRegistBtn = styled.div`
  display: flex;
  justify-content: space-between;
  @media ${props => props.theme.device.tablet} {
    margin-top: 10px;
  }
`;

const AdminSelectBoxWrap = styled.div`
  font-size: 16px;
  display: flex;
`;

interface VocItemData {
  no: number;
  title: string;
  content: string;
  name: string;
  dateTime: string;
  accept: string;
  phoneNumber: string;
  serviceSortation: string;
  email?: string;
  empId?: string;
  empNm?: string;
  fileOriginName?: string | null;
  fileName?: string | null;
  businessFileName?: string | null;
  businessFileOriginName?: string | null;
  employmentFileName?: string | null;
  employmentFileOriginName?: string | null;
  telecomFileName?: string | null;
  telecomFileOriginName?: string | null;
  consentFileName?: string | null;
  consentFileOriginName?: string | null;
  specialBusinessFileName?: string | null;
  specialBusinessFileOriginName?: string | null;
  transmissionFileName?: string | null;
  transmissionFileOriginName?: string | null;
}

const AdminVocDetailPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [item, setItem] = useState<VocItemData>({
    no: 0,
    title: '',
    content: '',
    name: '',
    dateTime: '',
    accept: '',
    phoneNumber: '',
    serviceSortation: '',
    email: '',
    empId: '',
    empNm: '',
    fileOriginName: null,
    fileName: null,
    businessFileName: null,
    businessFileOriginName: null,
    employmentFileName: null,
    employmentFileOriginName: null,
    telecomFileName: null,
    telecomFileOriginName: null,
    consentFileName: null,
    consentFileOriginName: null,
    specialBusinessFileName: null,
    specialBusinessFileOriginName: null,
    transmissionFileName: null,
    transmissionFileOriginName: null
  });
  const [selectAssignPerson, setSelectAssignPerson] = useState<string | undefined>(undefined);
  const [selectAssignPersonName, setSelectAssignPersonName] = useState<string | undefined>(
    undefined
  );
  const assignList = localStorage.getItem('assingPersonList');

  const assignPerson = assignList ? JSON.parse(assignList) : [];

  useEffect(() => {
    if (sessionStorage.getItem('isAdmin') !== 'true') {
      alert('로그인해주시기 바랍니다.');
      navigate('/AdminVocLogin');
    }
  }, [navigate]);

  const handleSelectBox = (assignID: string | undefined) => {
    setSelectAssignPerson(assignID);
  };

  const handleSelectBoxName = (assignName: string | undefined) => {
    setSelectAssignPersonName(assignName);
  };

  useEffect(() => {
    if (location.state) {
      console.debug('Admin detail page data:', location.state);
      setItem(location.state as VocItemData);
    }
  }, [location]);

  const navigateToList = () => {
    navigate(-1);
  };

  const handleClickBtn = async (param: string) => {
    if (param === '1' && selectAssignPerson === undefined) {
      alert('조치담당자를 설정해주세요 설정되지 않았습니다.');
      return;
    }
    const response = await AdminBoardService.updateAdminVoc(
      item.no,
      param,
      selectAssignPerson,
      selectAssignPersonName,
      item.serviceSortation
    );
    if (response.status === 'success') {
      navigate('/AdminVocBoard');
    }
  };
  const downloadFile = async (fileKey?: string, fileName?: string) => {
    const response = await AdminBoardService.fileDownload(item.no, fileKey, fileName);
    return response;
  };
  return (
    <AdminVocDtailWrap>
      <TitleHeader
        title={'접수페이지'}
        subTitle={'관리자용 고객 VOC 상세내역입니다. 승인 상태를 확인해 주세요.'}
      />
      <AdminVocDetailBoardView>
        <AdminDetailNumber>No.{item.no}</AdminDetailNumber>
        <AdminDetailBoardViewTop>
          <AdminVocDetailBoardViewTitle>제목 : {item.title}</AdminVocDetailBoardViewTitle>
          <AdminVocDetailBoardViewCnt>
            <AdminSelectBoxWrap>
              <p>담당자 배정:</p>
              {['접수', '삭제', '종료'].includes(item.accept) ? (
                <div>{item.empNm}</div>
              ) : (
                <SelectBox
                  selectLists={assignPerson}
                  handleSelectBox={handleSelectBox}
                  handleSelectBoxName={handleSelectBoxName}
                />
              )}
            </AdminSelectBoxWrap>
            <CntUsername>작성자 | {item.name}</CntUsername>
            <CntDate>작성일자 | {item.dateTime}</CntDate>
          </AdminVocDetailBoardViewCnt>
        </AdminDetailBoardViewTop>
        <AdminVocDetailPhoneNumber>▶ 등록자 연락처: {item.phoneNumber}</AdminVocDetailPhoneNumber>
        <AdminVocDetailBoardViewContent>{item.content}</AdminVocDetailBoardViewContent>
        <AdminVocDetailBoardViewFile>
          <AdminVocDetailBoardViewFileLine>
            <AdminDetailFileWrap>
              <AdminVocDetailBoardViewFileTitle>첨부파일</AdminVocDetailBoardViewFileTitle>
              {(() => {
                const rawFiles = getRawFilesFromItem(item as unknown as Record<string, unknown>);
                const files = rawFiles.map(f => {
                  const origin = normalizeName(f.originName);
                  const stored = normalizeName(f.storedName);
                  const display = origin || stored;
                  return { ...f, displayName: display, downloadName: origin || stored };
                });
                console.debug('Admin detail files:', files);
                const available = files.filter(f => !!f.displayName);
                if (available.length === 0)
                  return (
                    <AdminVocDetailBoardViewFilename>첨부파일 없음</AdminVocDetailBoardViewFilename>
                  );
                return (
                  <div>
                    {available.map((f, idx) => (
                      <div key={idx} style={{ marginBottom: '6px' }}>
                        <AdminVocDetailBoardViewFilename
                          onClick={() => {
                            downloadFile(f.key, f.downloadName as string);
                          }}
                        >
                          {f.label} : {f.displayName}
                        </AdminVocDetailBoardViewFilename>
                      </div>
                    ))}
                  </div>
                );
              })()}
            </AdminDetailFileWrap>
            <AdminVocServiceWrap>
              <AdminVocDetailBoardViewOrigin>서비스 분류</AdminVocDetailBoardViewOrigin>
              <AdminVocDetailBoardViewOriginCnt>
                {getServiceLabel(item.serviceSortation)}
              </AdminVocDetailBoardViewOriginCnt>
            </AdminVocServiceWrap>
          </AdminVocDetailBoardViewFileLine>
        </AdminVocDetailBoardViewFile>
      </AdminVocDetailBoardView>
      <AdminVocDetailButton>
        <Button
          onClick={navigateToList}
          text={'목록'}
          backgroundColor={'#388fc0'}
          fontColor={'white'}
          borderRadius={'5px'}
        />
        <AdminVocWritePageRegistBtn className="AdminVocWritePageRegistBtn">
          {(() => {
            const status = item.accept;
            if (status === '접수') {
              return (
                <Button
                  onClick={() => handleClickBtn('5')}
                  text={'VOC 종료'}
                  backgroundColor={'#388fc0'}
                  fontColor={'white'}
                  borderRadius={'5px'}
                />
              );
            }
            if (status === '종료' || status === '삭제') {
              return null;
            }
            if (status === '대기' || status === '보류') {
              return (
                <>
                  <Button
                    onClick={() => handleClickBtn('1')}
                    text={'VOC 접수'}
                    backgroundColor={'#388fc0'}
                    fontColor={'white'}
                    borderRadius={'5px'}
                  />
                  <Button
                    onClick={() => handleClickBtn('2')}
                    text={'보류'}
                    backgroundColor={'#fff'}
                    fontColor={'#388fc0'}
                    borderRadius={'5px'}
                  />
                  <Button
                    onClick={() => handleClickBtn('3')}
                    text={'삭제'}
                    backgroundColor={'#fff'}
                    fontColor={'#388fc0'}
                    borderRadius={'5px'}
                  />
                </>
              );
            }
            // Default case
            return (
              <>
                <Button
                  onClick={() => handleClickBtn('1')}
                  text={'VOC 접수'}
                  backgroundColor={'#388fc0'}
                  fontColor={'white'}
                  borderRadius={'5px'}
                />
                <Button
                  onClick={() => handleClickBtn('3')}
                  text={'삭제'}
                  backgroundColor={'#fff'}
                  fontColor={'#388fc0'}
                  borderRadius={'5px'}
                />
              </>
            );
          })()}
        </AdminVocWritePageRegistBtn>
      </AdminVocDetailButton>
    </AdminVocDtailWrap>
  );
};

export default AdminVocDetailPage;
